export default __webpack_public_path__ + "static/media/Success vector.70160cbe.svg";